import "./InputTextComponent.scss";
import Utils from "../../../../utils/index.js";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { t } from "i18next";
import { toast } from "react-toastify";

const InputTextComponent = ({
  id,
  label,
  description,
  title,
  formik,
  key,
  referenceId,
  dataurl,
  fetchdata,
  type = "input",
  instanceUuid,
  required,
  eventChatCreationRef,
  eventSessionRef,
  activeTab,
  onDataurlUpdate,
  fromWorkflow = false,
  handleFormBlur,
  assistantIndex,
  isEditable,
  hidden,
  defaultValue,
}) => {
  const token = Utils.getLocalStorageItem("_t");
  const [data, setData] = useState([]);

  const Link = ({ id, children, title }) => (
    <OverlayTrigger
      placement="left"
      overlay={<Tooltip id={id}>{title}</Tooltip>}
    >
      <span
        className="nav-item"
        style={{
          float: "right",
        }}
      >
        {children}
      </span>
    </OverlayTrigger>
  );
  // useEffect(() => {
  //   startSessionURL();
  // }, [dataurl]);

  // const startSessionURL = () => {
  //   const eventSource = new EventSource(
  //     `${process.env.REACT_APP_BASE_URL}/event/startSession/${token}`
  //   );

  //   eventSource.onmessage = (event) => {
  //     const receivedData = JSON.parse(event.data);
  //     if (receivedData?.active == true) {
  //       const updatedDataurl = dataurl?.map((urlData) => {
  //         if (urlData.url === receivedData.url && receivedData?.status) {
  //           if (receivedData?.status === "Y") {
  //             toast.success("File processed successfully !!");
  //           }
  //           return { ...urlData, status: receivedData?.status };
  //         }
  //         return urlData;
  //       });
  //       // onDataurlUpdate(updatedDataurl, assistantIndex);
  //     }
  //   };
  // };

  const uploadFilesMulti = async () => {
    try {
      if (activeTab === "context" && eventChatCreationRef.current) {
        eventChatCreationRef.current.close();
        eventChatCreationRef.current = null;
      }

      const addFileInfoResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}filehandler/addurlinfo`,
        {
          method: "POST",
          body: JSON.stringify({
            referenceId: referenceId,
            referenceType: "Instance",
            url: formik.values[id],
            instanceUuid: instanceUuid,
          }),
          headers: {
            "Content-Type": "application/json",
            "X-access-token": token,
          },
        }
      );

      const responseData = await addFileInfoResponse.json();

      await fetchdata();
      formik.setFieldValue(id, "");
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const deleteFilesMulti = async (data) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}filehandler/delete`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify({ key: data?.key }),
        }
      );
      if (!response.ok) {
        console.error("Failed to fetch configuration!");
        return;
      }
      const responseData = await response.json();
      if (responseData?.statusCode) {
        setData(() => {
          const data = { ...responseData?.data };
          data.type = data.fileName?.split(".").pop();
          data.size = data.fileSize;
          data.id = data._id;
          if (data.status === "Y") {
            data.status = "Y";
          } else if (data.status === "N") {
            data.status = "N";
          } else if (data.status === "E") {
            data.status = "error";
          }

          return data;
        });
        await fetchdata();
        formik.setFieldValue(id, "");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  return (
    <>
      {
        <div className="urlbox mb-4" key={key}>
          <label htmlFor={id}>
            <div className="heading-box">
              <h4 className="instruct-title">{title}</h4>
              {required && (
                <span style={{ color: "red", marginLeft: "4px" }}>*</span>
              )}
            </div>
          </label>
          <div className="mb-2 description">{description}</div>
          {!hidden || !defaultValue ? (
            <div className="d-flex gap-3">
              {type != "longtxt" && (
                <input
                  id={id}
                  name={id}
                  onChange={(e) => {
                    if (!hidden) {
                      formik.handleChange(e);
                    }
                  }}
                  value={hidden ? defaultValue || '' : formik.values[id]}
                  className="form-control select-input"
                  required={required}
                  disabled={!isEditable || hidden}
                  readOnly={hidden}
                  onBlur={(e) => {
                    if (!hidden) {
                      formik.handleBlur(e);
                      if (fromWorkflow && typeof handleFormBlur === "function") {
                        handleFormBlur(e);
                      }
                    }
                  }}
                />
              )}
              {type == "longtxt" && (
                <textarea
                  id={id}
                  name={id}
                  onChange={(e) => {
                    if (!hidden) {
                      formik.handleChange(e);
                    }
                  }}
                  value={hidden ? defaultValue || '' : formik.values[id]}
                  className="form-control select-input"
                  rows={2}
                  required={required}
                  disabled={!isEditable || hidden}
                  readOnly={hidden}
                  onBlur={(e) => {
                    if (!hidden) {
                      formik.handleBlur(e);
                      if (fromWorkflow && typeof handleFormBlur === "function") {
                        handleFormBlur(e);
                      }
                    }
                  }}
                />
              )}

              {type == "urllink" && (
                <button
                  className="upload-btn colored scan-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    if (formik.values[id]) {
                      uploadFilesMulti();
                    }
                  }}
                  disabled={formik.values[id] === "" || formik.errors[id]}
                  style={
                    formik.values[id] == "" ||
                    formik.errors[id] ||
                    formik.values[id] == undefined
                      ? { pointerEvents: "none", opacity: "0.5" }
                      : {}
                  }
                >
                  {t("capture")}
                </button>
              )}
            </div>
          ) : null}
          {formik.errors[id] ? (
            <div className="error mt-2">{formik.errors[id]}</div>
          ) : null}
        </div>
      }
      {type == "urllink" &&
        Array.isArray(dataurl) &&
        dataurl.length > 0 &&
        dataurl.map((item, key) => {
          const { _id: id, title, description, status } = item;
          return (
            <div className="urlbox mb-2" key={key}>
              <label htmlFor={item?.id}>{item?.title}</label>
              <div className="mb-2 description">{description}</div>
              <div className="d-flex gap-3">
                <input
                  id={id}
                  name={id}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  value={item?.url}
                  className="form-control"
                  disabled
                />

                <span
                  className="d-flex gap-2 inof-cons align-items-center"
                  style={{ alignItems: "center" }}
                >
                  {status === "E" && (
                    <Link
                      id="t-4"
                      title={
                        "Something went wrong. Please delete the file and try again."
                      }
                    >
                      <span>
                        <img src="/images/error_status.svg" alt=""/>
                      </span>
                    </Link>
                  )}
                  {status === "Y" ? (
                    <img src="/images/success_status.svg" alt=""/>
                  ) : (
                    status !== "E" && (
                      <Link
                        title={
                          "Your URL is being processed, will be ready shortly. You can wait or come back later."
                        }
                        id="t-1"
                      >
                        {" "}
                        <Spinner
                          animation="border"
                          style={{ width: "16px", height: "16px" }}
                        />
                      </Link>
                    )
                  )}
                  <img
                    src="/images/redbin.svg"
                    alt=""
                    style={{ cursor: "pointer" }}
                    onClick={() => deleteFilesMulti(item)}
                  />
                </span>
              </div>
            </div>
          );
        })}
      {type == "urllink" && dataurl.length > 0 ? (
        <div className="d-flex justify-content-end">
          <button
            style={{
              fontSize: "12px",
              cursor: "pointer",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
            className="rfresh-btn"
            onClick={(e) => {
              e.preventDefault();
              fetchdata();
            }}
          >
            <img src="/images/refreshwhite.svg" alt=""/>
          </button>
        </div>
      ) : (
        ""
      )}
      {/* <div className="upload-file-box" key={key}>
        <label htmlFor={id}>{title}</label>
        <div className="mb-2 description">{description}</div>
        <input
          id={id}
          name={id}
          className="form-control mb-2"
          onChange={(e) => {
            formik.handleChange(e);
          }}
          value={formik.values[id] || ""}
        />
        {formik.errors[id] && formik.touched[id] && (
          <div className="error">{formik.errors[id]}</div>
        )}
      </div> */}
    </>
  );
};

export default InputTextComponent;
